import { Controller } from "@hotwired/stimulus"
import * as Routes from "routes"

export default class extends Controller {
  static targets = [
    "featureModal"
  ]

  connect() {
    this.bulkAgentsSelected = []
  }

  get filterPath() {
    const resource = this.data.get("resource")
    return resource === "accounts" ? (
      Routes.account_antiviruses_path
    ) : (
      Routes.organization_antiviruses_path.bind(null, this.data.get("resourceId"))
    )
  }

  get currentFilters() {
    return JSON.parse(this.data.get("filters")) || {}
  }

  get tableController() {
    return this.application.getControllerForElementAndIdentifier(
      this.element.querySelector("#antivirus-table"), "components--table"
    )
  }

  closeFeatureModal() {
    $(this.featureModalTarget).modal("hide")
  }
}
